/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { NotificationService } from 'excellence-ui';
import { ChunkLoadErrorNotification } from '../../../shared/notifications/chunk-load-error-notification/chunk-load-error-notification';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private notificationService = inject(NotificationService);

  private sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/i;
    const dynamicImportFailedMessage = 'Failed to fetch';
    // Angular sometimes wraps errors (e.g., in Promises).
    const errorMessage = error?.message || error?.rejection?.message || error?.toString() || '';

    if (
      typeof errorMessage === 'string' &&
      (chunkFailedMessage.test(errorMessage) || errorMessage.includes(dynamicImportFailedMessage))
    ) {
      Sentry.captureMessage(
        'ChunkLoadError - Suggesting page reload to fetch new version - ' + errorMessage,
        'warning',
      );
      this.showUpdateNotification();
    } else {
      this.sentryErrorHandler.handleError(error);
    }
  }

  private showUpdateNotification() {
    this.notificationService.show({ component: ChunkLoadErrorNotification, duration: 0 });
  }
}
